import { resolveTheme, WelcomeForm } from "@heraion/ui";
import { useAuth } from "./auth/AuthContext";
import { useThemePalette } from "./theme";

// Montaggio sottile del form condiviso: risolve il tema del web e cabla il
// submit sull'unica cosa che il web sa fare e il form no — chiudere la sfida
// e scrivere il profilo. ⛔ Nessuna logica qui dentro: se ne cresce, cresce
// nel componente condiviso, che è quello che monta anche mobile.
export function WelcomeGate() {
  const { completeNewPassword } = useAuth();
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);

  return (
    <WelcomeForm
      theme={theme}
      onComplete={({ newPassword, name, ageDeclaredAt }) =>
        completeNewPassword(newPassword, name, ageDeclaredAt)
      }
    />
  );
}
